<template>
  <card>
    <list
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="false"
      :itemLink="itemLink"
      :dateFilter="dateFilter"
      :setLink="setLink"
      :fields="fields"
      :filters="filters"
      :staticFilters="staticFilters"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"

      v-model="val"
    />
  </card>
</template>
<script>
export default {
name: "products",
methods: {
changeFunction(val) { },
change(val) { },

},
data() {
return {
  params: {},
  dateFilter: [
    {
      key: 'from_at',
      title: 'Начало даты',
    },
    {
      key: 'till_at',
      title: 'Конец даты',
    },
  ],
  filters: [
    {
      key: "shop",
      title: "Магазин",
      titleKey: 'name'
    },
    {
      key: "dealer",
      title: "Бизнес",
      titleKey: 'llc_name'
    },

  ],
  staticFilters: [

  ],
  val: [],
  modalCreate: "order",
  fields: [

  ],
  /** APIs */
  removeLink: "",
  cardLink: "item_user_stat",
  itemLink: "ratings",
  setLink: "ratings",
  columns: [
    {
      key: "id",
      title: "ID",
      checkbox: false,
      control: false,
      align: "left",
      timer: false,
      detail: false,
      // sortBy:'id'
    },
    {
      key: "name",
      title: "Торговый представитель",
      checkbox: false,
      disableLink: true,
      align: "left",
      timer: false,
      full: true,
      detail: false,
    },
    //  {
    //     key: "role",
    //     object: "title",
    //     title: "Текущая роль",
    //     checkbox: false,
    //     disableLink: true,
    //     control: false,
    //     align: "left",
    //     timer: false,
    //     detail: false,
    //   },
    {
      key: "shops_count",
      title: "Кол-во открытых ТТ",
      checkbox: false,
      control: false,
      align: "left",
      timer: false,
      detail: false,
    },

    {
      key: "orders_count",
      title: "Кол-во всех заказов ",
      checkbox: false,
      control: false,
      align: "left",
      timer: false,
      detail: false,
    },
    {
      key: "orders_done_count",
      title: "Кол-во выполненных заказов ",
      checkbox: false,
      control: false,
      align: "left",
      timer: false,
      detail: false,
    },

    {
      key: "purchases_total",
      title: "Кол-во проданных бутылок",
      checkbox: false,
      control: false,
      align: "left",
      timer: false,
      detail: false,
    },

    {
      key: "order_prices_total",
      title: "Сумма выполненных заказов",
      checkbox: false,
      control: false,
      align: "left",
      timer: false,
      detail: false,
    },


    // {
    //   key: "created_at",
    //   title: "Создан",
    //   dateTimeFormat: true,
    //   full: true,
    // },
    {
      detail: true,
      // remove: true,
    },
  ],
};
},
};
</script>
<style></style>
